<div class="grid-container padding-y-4">
  <div class="grid-row">
    <h3 class="usa-legend usa-legend--large">Master Data Admin</h3>
  </div>

  <form id="masterDataAdminForm" role="form" [formGroup]="masterDataAdminForm" aria-label="masterDataAdminForm">
    <div class="grid-row">
      @if (this.retrieveSuccess === false) {
        <div class="usa-alert usa-alert--error usa-alert--slim">
          <div class="usa-alert__body">
            <p class="usa-alert__text">
              {{this.retieveErrorMessage}}
            </p>
          </div>
        </div>
      }
      @if (this.saveSuccess === true) {
        <div class="usa-alert usa-alert--error usa-alert--slim">
          <div class="usa-alert__body">
            <p class="usa-alert__text">
              {{this.saveSuccessMessage}}
            </p>
          </div>
        </div>
      }
      @if (this.saveSuccess === false) {
        <div class="usa-alert usa-alert--error usa-alert--slim">
          <div class="usa-alert__body">
            <p class="usa-alert__text">
              {{this.saveErrorMessage}}
            </p>
          </div>
        </div>
      }
    </div>

    <div class="grid-row grid-gap">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <label for="masterdata_type" class="usa-label">Master Data<abbr title="required"
        class="usa-hint usa-hint--required">*</abbr></label>
        <select id="masterdata_type" class="usa-select" formControlName="masterDataType"
          (change)="masterDataTypeChange()" required>
          <option value='null' selected disabled>Choose...</option>
          @for (mdt of masterDataAdminTypes; track mdt) {
            <option [ngValue]="mdt">{{mdt}}</option>
          }
        </select>
      </div>
    </div>

    @if (showCountryFields) {
      <div>
        <div class="grid-row grid-gap">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <label for="country-code" class="usa-label">Country Code<abbr title="required"
            class="usa-hint usa-hint--required">*</abbr></label>
            <input type="text" class="usa-input margin-right-05" placeholder="Enter Country Code" id="country-code"
              formControlName='countryCode'>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4 position-relative">
              <button type="button" class="usa-button pin-bottom" type="submit"
                (click)="findCountryDetails(this.masterDataAdminForm.get('countryCode').value)">Search
              </button>
            </div>
          </div>
          <div class="grid-row grid-gap">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label class="usa-label" for="country-name">Country Name<abbr title="required"
              class="usa-hint usa-hint--required">*</abbr></label>
              <input type="text" placeholder="Enter Country Name" id="country-name" class="usa-input"
                formControlName='countryName'>
              </div>
            </div>
            <div class="grid-row padding-top-4">
              @if (!this.isCreate) {
                <button type="button" class="usa-button"
                  (click)="saveOrUpdateStateCountry();">Save
                </button>
              }
              @if (!this.isCreate) {
                <button type="button" class="usa-button usa-button--outline"
                  (click)="deleteStateCountry()">Delete
                </button>
              }
              <button type="button" class="usa-button usa-button--outline" (click)="viewAuditTrialForCountry()">View Audit
                Trail
              </button>
            </div>
          </div>
        }

        @if (showServiceAreaFields) {
          <div>
            <div class="grid-row grid-gap">
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                <label for="servicearea-code" class="usa-label">Service Area Code<abbr title="required"
                class="usa-hint usa-hint--required">*</abbr></label>
                <input type="text" placeholder="Enter Service Area Code" id="servicearea-code"
                  class="usa-input margin-right-05" formControlName='serviceAreaCode'>
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                  <button type="button" class="usa-button pin-bottom" type="submit"
                    (click)="findCountryDetails(this.masterDataAdminForm.get('serviceAreaCode').value)">
                    Search
                  </button>
                </div>
              </div>
              <div class="grid-row grid-gap">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                  <label for="description" class="usa-label">Description<abbr title="required"
                  class="usa-hint usa-hint--required">*</abbr></label>
                  <input type="text" placeholder="Enter Description" id="description" class="usa-input"
                    formControlName='description'>
                  </div>
                </div>
                <div class="grid-row padding-top-4">
                  @if (!this.isCreate) {
                    <button type="button" class="usa-button"
                      (click)="saveOrUpdateStateCountry();">Save
                    </button>
                  }
                  @if (!this.isCreate) {
                    <button type="button" class="usa-button usa-button--outline"
                      (click)="deleteStateCountry()">Delete
                    </button>
                  }
                  <button type="button" class="usa-button usa-button--outline" (click)="viewAuditTrialForServiceArea()">View Audit
                    Trails
                  </button>
                </div>
              </div>
            }

            @if (showCountyFields) {
              <div>
                <div class="grid-row grid-gap">
                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    <label for="county-name" class="usa-label">County Name<abbr title="required"
                    class="usa-hint usa-hint--required">*</abbr></label>
                    <input type="text" placeholder="Enter County Name" id="county-name" class="usa-input"
                      formControlName='countyName'>
                    </div>
                  </div>
                  <div class="grid-row grid-gap">
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                      <label for="State Abbreviation" class="usa-label">State Abbreviation<abbr title="required"
                      class="usa-hint usa-hint--required">*</abbr></label>
                      <input type="text" placeholder="Enter State Abbreviation" id="state-Abbreviation"
                        class="usa-input margin-right-05" formControlName='stateAbbreviation'>
                      </div>
                      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                        <button type="button" class="usa-button pin-bottom" type="submit"
                          (click)="findCountyDetails(this.masterDataAdminForm.get('countyName').value, this.masterDataAdminForm.get('stateAbbreviation').value)">
                          Search
                        </button>
                      </div>
                    </div>
                    <div class="grid-row grid-gap">
                      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                        <label for="county-code" class="usa-label">County Code<abbr title="required"
                        class="usa-hint usa-hint--required">*</abbr></label>
                        <input type="text" placeholder="Enter County Code" id="county-code" class="usa-input"
                          formControlName='countyCode'>
                        </div>
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                          <label for="icc" class="usa-label">ICC<abbr title="required"
                          class="usa-hint usa-hint--required">*</abbr></label>
                          <input type="text" placeholder="Enter ICC" id="icc-id" class="usa-input"
                            formControlName='iccId'>
                          </div>
                          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                            <label for="gsa-service-area" class="usa-label">GSA Service Area<abbr title="required"
                            class="usa-hint usa-hint--required">*</abbr></label>
                            <input type="text" placeholder="Enter GSA Service Area" id="gsa-ServiceArea"
                              class="usa-input" formControlName='gsaServiceArea'>
                            </div>
                          </div>
                          <div class="grid-row padding-top-4">
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                              @if (!this.isCreate) {
                                <button type="button" class="usa-button"
                                  (click)="saveOrUpdateCounty()">Save
                                </button>
                              }
                              @if (!this.isCreate) {
                                <button type="button" class="usa-button usa-button--outline"
                                  (click)="deleteCounty()">Delete
                                </button>
                              }
                              <button type="button" class="usa-button usa-button--outline" (click)="viewAuditTrialForCounty()">View Audit
                                Trails
                              </button>
                            </div>
                          </div>
                        </div>
                      }

                      @if (showFreightServicesMasterFields) {
                        <div>
                          <div class="grid-row grid-gap">
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                              <label for="rate_period" class="usa-label">Rate Period<abbr title="required"
                              class="usa-hint usa-hint--required">*</abbr></label>
                              <select id="rate_period" class="usa-select" formControlName="ratePeriod"
                                (change)="onRatePeriodChange()" required>
                                <option value='null' selected disabled>Select rate period...</option>
                                @for (ratePeriodDetail of ratePeriodDetails; track ratePeriodDetail) {
                                  <option
                                    [value]="ratePeriodDetail.controlId">
                                    {{ratePeriodDetail.effectiveDate | date: 'M/d/y'}} -
                                  {{ratePeriodDetail.expiryDate | date: 'M/d/y'}}</option>
                                }
                              </select>
                            </div>
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                              <label for="rate_type" class="usa-label">Rate Type<abbr title="required"
                              class="usa-hint usa-hint--required">*</abbr></label>
                              <select id="rate_type" class="usa-select" formControlName="freightRateType"
                                (change)="onRateTypeChange()" required>
                                <option value='null' selected disabled>Choose...</option>
                                @for (rt of freightRateTypes; track rt) {
                                  <option [ngValue]="rt">{{rt}}</option>
                                }
                              </select>
                            </div>
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                              <label for="agency_id" class="usa-label">SRO ID<abbr title="required"
                              class="usa-hint usa-hint--required">*</abbr></label>
                              <select id="agency_id" class="usa-select" formControlName="sroId"
                                (change)="onSroIdChange()">
                                <option value='null' selected disabled>Choose...</option>
                                @for (sro of sroIdList; track sro) {
                                  <option [value]="sro.sroMasterId">{{sro.sroId}}
                                  </option>
                                }
                              </select>
                            </div>
                          </div>
                          @if (showltl) {
                            <div>
                              <div class="grid-row grid-gap">
                                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                                  <label for="ltl_minimum_pct" class="usa-label">LTL Minimum Value<abbr title="required"
                                  class="usa-hint usa-hint--required">*</abbr></label>
                                  <input type="text" id="ltl_minimum_pct" class="usa-input"
                                    formControlName="ltlMinimumPct" appNumbersOnly>
                                  </div>
                                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                                    <label for="ltl_maximum_pct" class="usa-label">LTL Maximum Value<abbr title="required"
                                    class="usa-hint usa-hint--required">*</abbr></label>
                                    <input type="text" id="ltl_maximum_pct" class="usa-input"
                                      formControlName="ltlMaximumPct" appNumbersOnly>
                                    </div>
                                  </div>
                                </div>
                              }
                              @if (showtl) {
                                <div>
                                  <div class="grid-row grid-gap">
                                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                                      <label for="tl_minimum_pct" class="usa-label">TL Minimum Value<abbr title="required"
                                      class="usa-hint usa-hint--required">*</abbr></label>
                                      <input type="text" id="tl_minimum_pct" class="usa-input"
                                        formControlName="tlMinimumPct" appNumbersOnly>
                                      </div>
                                      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                                        <label for="tl_maximum_pct" class="usa-label">TL Maximum Value<abbr title="required"
                                        class="usa-hint usa-hint--required">*</abbr></label>
                                        <input type="text" id="tl_maximum_pct" class="usa-input"
                                          formControlName="tlMaximumPct" appNumbersOnly>
                                        </div>
                                      </div>
                                    </div>
                                  }
                                  @if (showltl || showtl) {
                                    <div>
                                      <div class="grid-row padding-top-4">
                                        @if (!this.isCreate) {
                                          <button type="button" class="usa-button"
                                            (click)="saveFreightServiceMaster()">Save
                                          </button>
                                        }
                                        @if (!this.isCreate) {
                                          <button type="button" class="usa-button usa-button--outline"
                                            >Delete
                                          </button>
                                        }
                                      </div>
                                    </div>
                                  }
                                </div>
                              }
                              @if (this.showTable) {
                                <div>
                                  <div class="usa-table usa-table--borderless">
                                    <ag-grid-angular class="ag-theme-alpine" style="width: 100%;"
                                      [rowData]="frtRatePeriodDetails" [domLayout]="domLayout" [pagination]="true"
                                      [paginationPageSize]="paginationPageSize" [columnDefs]="columnDefs"
                                      (gridReady)="onGridReady($event)" ag-grid-resize>
                                    </ag-grid-angular>
                                  </div>
                                </div>
                              }
                              @if (showCarrierRfsps) {
                                <div>
                                  <div class="grid-row grid-gap">
                                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                                      <label for="carrier-id-rfsp" class="usa-label">Rate File Service Provider<abbr title="required"
                                      class="usa-hint usa-hint--required">*</abbr></label>
                                      <select id="carrier-id-rfsp" class="usa-select" formControlName="carrierIdRfsp"
                                        (change)="onCarrierIdRfspsChange()" required>
                                        <option value='null' selected disabled>Choose...</option>
                                        @for (crfsps of carrierRfsps; track crfsps) {
                                          <option [ngValue]="crfsps.scac">
                                          {{crfsps.scac}}</option>
                                        }
                                      </select>
                                    </div>
                                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                                      <label for="carrier-id-tsp" class="usa-label">Transportation Service Provider<abbr title="required"
                                      class="usa-hint usa-hint--required">*</abbr></label>
                                      <input type="text" placeholder="Enter Carrier Transportation Service provider"
                                        id="carrier-id-tsp" class="usa-input" formControlName='carrierIdTsp'
                                        [typeahead]="typeaheadlist" [typeaheadMinLength]="minLengthToSearch"
                                        [typeaheadOptionsLimit]="10" [maxlength]="maxCharLength"
                                        oninput="this.value = this.value.toUpperCase()">
                                      </div>
                                    </div>
                                    <div class="grid-row grid-gap">
                                      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                                        <label for="shipment-type" class="usa-label">Shipment Type<abbr title="required"
                                        class="usa-hint usa-hint--required">*</abbr></label>
                                        <select id="shipment-type" class="usa-select" formControlName="shipmentType" required>
                                          <option value='null' selected disabled>Choose...</option>
                                          @for (ST of shipmentTypes; track ST) {
                                            <option [ngValue]="ST">{{ST}}</option>
                                          }
                                        </select>
                                      </div>
                                    </div>
                                    <div class="grid-row padding-top-4">
                                      @if (!this.isCreate) {
                                        <button type="button" class="usa-button"
                                          (click)="saveOrUpdateCarrierRfsps()">Save
                                        </button>
                                      }
                                      @if (!this.isCreate) {
                                        <button type="button" class="usa-button usa-button--outline"
                                          (click)="deleteCarrierRfsps()">Delete
                                        </button>
                                      }
                                      <button type="button" class="usa-button usa-button--outline" (click)="viewAuditTrialForRFSP()">View Audit
                                        Trails
                                      </button>
                                    </div>
                                    @if (this.showRfspsTable) {
                                      <div>
                                        <div class="usa-table usa-table--borderless">
                                          <ag-grid-angular class="ag-theme-alpine" style="width: 100%;"
                                            [gridOptions]="rfspResultsGridOptions" [rowData]="carrierRfspsDetails"
                                            [domLayout]="domLayout" [pagination]="true"
                                            [paginationPageSize]="paginationPageSize" [columnDefs]="carrierRfspColumnDefs"
                                            [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                            [suppressDragLeaveHidesColumns]="true" (gridReady)="onGridReady($event)">
                                          </ag-grid-angular>
                                        </div>
                                      </div>
                                    }
                                  </div>
                                }

                                @if (showControlKeys) {
                                  <div>
                                    <div class="grid-row grid-gap">
                                      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                                        <label for="control_type" class="usa-label">Control Type<abbr title="required"
                                        class="usa-hint usa-hint--required">*</abbr></label>
                                        <select id="control_type" class="usa-select" formControlName="controlTypeSelected"
                                          (change)="onControlTypeChange()" required>
                                          <option value='null' selected disabled>Select control type...</option>
                                          @for (ckct of controlKeysControlTypes; track ckct) {
                                            <option [ngValue]="ckct">{{ckct}}
                                            </option>
                                          }
                                        </select>
                                      </div>
                                      @if (this.showPcmilerVersion) {
                                        <div
                                          class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                                          <label for="pcmiler_version" class="usa-label">Version<abbr title="required"
                                          class="usa-hint usa-hint--required">*</abbr></label>
                                          <input type="text" id="pcmiler_version" class="usa-input" formControlName="pcMilerVersion" appNumbersOnly>
                                        </div>
                                      }
                                    </div>
                                    <div class="grid-row grid-gap">
                                      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                                        <label for="effective_date" class="usa-label">Effective Date<abbr title="required"
                                        class="usa-hint usa-hint--required">*</abbr></label>
                                        <input type="text" id="effective_date" class="usa-input" placeholder="mm/dd/yyyy"
                                          formControlName="effectiveDate" bsDatepicker [bsConfig]="datePickerConfig"
                                          placement="right">
                                        </div>
                                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                                          <label for="expiry_date" class="usa-label">Expiry Date<abbr title="required"
                                          class="usa-hint usa-hint--required">*</abbr></label>
                                          <input type="text" id="expiry_date" class="usa-input" placeholder="mm/dd/yyyy"
                                            formControlName="expiryDate" bsDatepicker [bsConfig]="datePickerConfig"
                                            placement="right">
                                          </div>
                                        </div>
                                        <div class="grid-row padding-top-4">
                                          @if (!this.isCreate) {
                                            <button type="button" class="usa-button"
                                              (click)="saveOrUpdateControlKeys()">Save
                                            </button>
                                          }
                                          @if (!this.isCreate) {
                                            <button type="button" class="usa-button usa-button--outline"
                                              (click)="deleteControlKeys()">Delete
                                            </button>
                                          }
                                          <button type="button" class="usa-button usa-button--outline" (click)="viewAuditControlType()">View Audit
                                            Trails
                                          </button>
                                        </div>
                                        @if (this.showControlKeysTable) {
                                          <div>
                                            <div class="usa-table usa-table--borderless">
                                              <ag-grid-angular class="ag-theme-alpine" style="width: 100%;"
                                                [rowData]="controlKeyDetails" [domLayout]="domLayout" [pagination]="true"
                                                [paginationPageSize]="paginationPageSize" [columnDefs]="controlKeysColumnDefs"
                                                (gridReady)="onGridReady($event)">
                                              </ag-grid-angular>
                                            </div>
                                          </div>
                                        }
                                      </div>
                                    }

                                    @if (showDieselPriceFields) {
                                      <div>
                                        <div class="grid-row grid-gap">
                                          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                                            <label for="year" class="usa-label">Year<abbr title="required"
                                            class="usa-hint usa-hint--required">*</abbr></label>
                                            <select id="select-year" class="usa-select margin-right-05" formControlName="year" required>
                                              <option value='null' selected disabled>Select Year...</option>
                                              @for (year of years; track year) {
                                                <option [ngValue]="year">{{year}}
                                                </option>
                                              }
                                            </select>
                                          </div>
                                          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                                            <button type="button" class="usa-button pin-bottom" (click)="populateDieselPriceHistory()" type="submit">Price
                                              History
                                            </button>
                                          </div>
                                        </div>
                                        <div class="grid-row grid-gap">
                                          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                                            <label for="entry_date" class="usa-label">Entry Date<abbr title="required"
                                            class="usa-hint usa-hint--required">*</abbr></label>
                                            <input type="text" id="entry_date" class="usa-input" placeholder="mm/dd/yyyy"
                                              formControlName="entryDate" bsDatepicker [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}"
                                              placement="right" [daysDisabled]="[0,2,3,4,5,6]">
                                            </div>
                                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                                              <label for="dollars_per_gallon" class="usa-label">Dollars per Gallon<abbr title="required"
                                              class="usa-hint usa-hint--required">*</abbr></label>
                                              <input type="text" id="dollars_per_gallon" class="usa-input"
                                                formControlName="dollarsPerGallon" [maxlength]=5 appNumbersOnly>
                                                @if (this.masterDataAdminForm.get('dollarsPerGallon').touched && this.masterDataAdminForm.get('dollarsPerGallon').hasError('required')) {
                                                  <div class="site-preview-heading required"
                                                    >
                                                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                                      <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                                                    </svg>
                                                    Diesel Price is required
                                                  </div>
                                                }
                                                @if (this.masterDataAdminForm.get('dollarsPerGallon').touched && this.masterDataAdminForm.get('dollarsPerGallon').hasError('pattern')) {
                                                  <div class="site-preview-heading required"
                                                    >
                                                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                                      <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                                                    </svg>
                                                    Diesel Price is invalid
                                                  </div>
                                                }
                                              </div>
                                            </div>
                                            <div class="grid-row padding-top-4">
                                              @if (!this.isCreate) {
                                                <button type="button" class="usa-button"
                                                  (click)="saveFrtDieselPrice();">Save
                                                </button>
                                              }
                                              <button type="button" class="usa-button"
                                                (click)="viewAuditTrialForDieselPrice()">View Audit Trails
                                              </button>
                                            </div>
                                            @if (this.showDieselPriceTable) {
                                              <p class="padding-top-4 required">
                                                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                                  <use xlink:href="/assets/uswds/img/sprite.svg#info"></use>
                                                </svg>
                                                Note: Please click on individual price cell to update the price.
                                              </p>
                                            }
                                            @if (this.showDieselPriceTable) {
                                              <div>
                                                <div class="usa-table usa-table--borderless">
                                                  <ag-grid-angular class="ag-theme-alpine" style="width: 100%;"
                                                    [rowData]="dieselPriceDetails" [domLayout]="domLayout" [pagination]="true"
                                                    [paginationPageSize]="paginationPageSize" [columnDefs]="dieselPriceColumnDefs"
                                                    (cellValueChanged)="onCellValueChanged($event)"
                                                    (gridReady)="onGridReady($event)">
                                                  </ag-grid-angular>
                                                </div>
                                              </div>
                                            }
                                          </div>
                                        }

                                        @if (showZonesFields) {
                                          <div>
                                            <div class="grid-row grid-gap">
                                              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                                                <label for="search-agency-name" class="usa-label">Agency Name</label>
                                                <select id="search-agency-name" class="usa-select" formControlName='agencyName'
                                                  (change)="onCustomerNameChange($event.target.value)">
                                                  <option hidden value='' selected disabled>Choose...</option>
                                                  @for (agency of agencyCustomerList; track agency) {
                                                    <option [value]="agency.agencyCode">
                                                    {{agency.agencyBureauName}} - {{agency.agencyCode}}</option>
                                                  }
                                                </select>
                                              </div>
                                              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                                                <label for="search-bureau-name" class="usa-label">Bureau Name</label>
                                                <select id="search-bureau-name" class="usa-select" formControlName='bureauName'
                                                  (change)="onBureauNameChange()">
                                                  <option hidden value='' selected disabled>Choose...</option>
                                                  @for (bureau of agencyBureauList; track bureau) {
                                                    <option [value]="bureau.bureauCode">
                                                      {{bureau.agencyBureauName}} - {{bureau.bureauCode}}
                                                    </option>
                                                  }
                                                </select>
                                              </div>
                                            </div>
                                            <div class="grid-row grid-gap">
                                              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                                                <label for="zone-code" class="usa-label">Zone Code<abbr title="required"
                                                class="usa-hint usa-hint--required">*</abbr></label>
                                                <input type="text" placeholder="Enter Zone Code"
                                                  [attr.disabled]="keywordDisabled?'':null" id="zone-code" class="usa-input"
                                                  formControlName='zoneCode' [typeahead]="zonecodetypeaheadlist"
                                                  [typeaheadMinLength]="zoneCodeMinLengthToSearch" [typeaheadOptionsLimit]="10"
                                                  [maxlength]="zoneCodeMaxCharLength">
                                                </div>
                                                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                                                  <label for="zone-name" class="usa-label">Zone Name<abbr title="required"
                                                  class="usa-hint usa-hint--required">*</abbr></label>
                                                  <input type="text" placeholder="Enter Zone Name"
                                                    [attr.disabled]="keywordDisabled?'':null" id="zone-name" class="usa-input"
                                                    formControlName='zoneName' [typeahead]="zonenametypeaheadlist"
                                                    [typeaheadMinLength]="zoneNameMinLengthToSearch" [typeaheadOptionsLimit]="10"
                                                    [maxlength]="zoneNameMaxCharLength">
                                                  </div>
                                                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                                                    <label for="country_ext" class="usa-label">Country<abbr title="required"
                                                    class="usa-hint usa-hint--required">*</abbr></label>
                                                    <select id="country_ext" class="usa-select" formControlName="country" name="country"
                                                      (change)="onCountryChange()">
                                                      <option [value]='null' selected disabled>Choose...</option>
                                                      @for (c of countryList; track c) {
                                                        <option [value]="c.stateCountryId">
                                                        {{c.stateCountryName}}</option>
                                                      }
                                                    </select>
                                                  </div>
                                                </div>
                                                <div class="grid-row grid-gap">
                                                  @if (isCountryUsa) {
                                                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                                                      <ng-template #customItemTemplate let-model="item">{{model.cityName}},
                                                        {{model.stateAbbrev}} {{model.zipCode}}
                                                      </ng-template>
                                                      <label class="usa-label" for="OriginSearchString">Search by City or Zip: </label> <input
                                                      id="OriginSearchString" class="usa-input" formControlName="asyncOriginSearchString"
                                                      [typeaheadAsync]="true" [typeahead]="dataSourceOrigin"
                                                      (typeaheadLoading)="changeTypeaheadOriginLoading($event)"
                                                      (typeaheadOnSelect)="typeaheadOriginOnSelect($event)"
                                                      typeaheadOptionField="cityName" [typeaheadItemTemplate]="customItemTemplate"
                                                      [typeaheadWaitMs]="1000" [typeaheadScrollable]="true"
                                                      [typeaheadOptionsInScrollableView]="10" [typeaheadOptionsLimit]="100"
                                                      placeholder="Type a location or zip">
                                                      @if (typeaheadLoading) {
                                                        <div>Loading...</div>
                                                      }
                                                    </div>
                                                  }
                                                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                                                    <label for="city-name" class="usa-label">City Name<abbr title="required"
                                                    class="usa-hint usa-hint--required">*</abbr></label>
                                                    <input type="text" id="city-name" class="usa-input" formControlName='city'>
                                                  </div>
                                                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                                                    <label for="state-code" class="usa-label">State Code@if (this.isCountryUSA) {
                                                      <small class="usa-hint usa-hint--required"
                                                      >*</small>
                                                    }</label>
                                                    <input type="text" id="state-code" class="usa-input" formControlName='state'>
                                                  </div>
                                                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                                                    <label for="zip-code" class="usa-label">Zip Code@if (this.isCountryUSA) {
                                                      <small class="usa-hint usa-hint--required"
                                                      >*</small>
                                                    }</label>
                                                    <input type="text" id="zip-code" class="usa-input" formControlName='zip'>
                                                  </div>
                                                </div>
                                                <div class="grid-row padding-top-4">
                                                  @if (!this.isCreate) {
                                                    <button type="button" class="usa-button"
                                                      (click)="saveFrtRatesZone()">Save
                                                    </button>
                                                  }
                                                  @if (!this.isCreate) {
                                                    <button type="button" class="usa-button usa-button--outline"
                                                      (click)="resetFrtRatesZone()">Reset
                                                    </button>
                                                  }
                                                  <button type="button" class="usa-button usa-button--outline"
                                                    (click)="viewAuditTrailZone()">View Audit Trail
                                                  </button>
                                                </div>
                                                @if (this.showZonesTable) {
                                                  <div>
                                                    <div class="usa-table usa-table--borderless">
                                                      <ag-grid-angular class="ag-theme-alpine" style="width: 100%;" [rowData]="frtZones"
                                                        [domLayout]="domLayout" [pagination]="true"
                                                        [paginationPageSize]="paginationPageSize" [columnDefs]="zonesColumnDefs"
                                                        (gridReady)="onGridReady($event)">
                                                      </ag-grid-angular>
                                                    </div>
                                                  </div>
                                                }
                                              </div>
                                            }

                                            @if (showCustomerSatisfactionIndexFields) {
                                              <div>
                                                <div class="grid-row grid-gap">
                                                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                                                    <label for="csi_rate_period" class="usa-label">Rate Period<abbr title="required"
                                                    class="usa-hint usa-hint--required">*</abbr></label>
                                                    <select id="csi_rate_period" class="usa-select" formControlName="csiRatePeriod"
                                                      (change)="onCsiRatePeriodChange()" required>
                                                      <option value='null' selected disabled>Select rate period...</option>
                                                      @for (csiRatePeriodDetail of csiRatePeriodDetails; track csiRatePeriodDetail) {
                                                        <option
                                                          [value]="csiRatePeriodDetail.controlId">
                                                          {{csiRatePeriodDetail.effectiveDate | date: 'M/d/y'}} -
                                                        {{csiRatePeriodDetail.expiryDate | date: 'M/d/y'}}</option>
                                                      }
                                                    </select>
                                                  </div>
                                                </div>
                                                <div class="grid-row grid-gap">
                                                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                                                    <label for="csi_scac" class="usa-label">SCAC<abbr title="required"
                                                    class="usa-hint usa-hint--required">*</abbr></label>
                                                    <input type="text" id="csi_scac" class="usa-input" maxlength="4" formControlName="csiScac">
                                                    @if (this.masterDataAdminForm.get('csiScac').invalid || this.masterDataAdminForm.get('csiScac').hasError('pattern')) {
                                                      <div class="usa-error-message"
                                                        >
                                                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                                          <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                                                        </svg>
                                                        SCAC code is invalid
                                                      </div>
                                                    }
                                                  </div>
                                                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                                                    <label for="csi_domestic" class="usa-label">CSI Domestic<abbr title="required"
                                                    class="usa-hint usa-hint--required">*</abbr></label>
                                                    <input type="text" id="csi_domestic" class="usa-input" formControlName="csiDomestic" appTwoDigitDecimalNumber>
                                                    <!--<div class= "usa-error-message" *ngIf="this.masterDataAdminForm.get('csiDomestic').invalid || this.masterDataAdminForm.get('csiDomestic').hasError('pattern')">
                                                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                                      <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                                                    </svg>CSI Domestic is invalid
                                                  </div>-->
                                                </div>
                                                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                                                  <label for="csi_international" class="usa-label">CSI International<abbr title="required"
                                                  class="usa-hint usa-hint--required">*</abbr></label>
                                                  <input type="text" id="csi_international" class="usa-input"
                                                    formControlName="csiInternational" appTwoDigitDecimalNumber>
                                                    <!--<div class= "usa-error-message" *ngIf="this.masterDataAdminForm.get('csiInternational').invalid">
                                                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                                      <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                                                    </svg>CSI International is invalid
                                                  </div>-->
                                                </div>
                                              </div>
                                              <div class="grid-row padding-top-4">
                                                @if (!this.isCreate) {
                                                  <button type="button" class="usa-button"
                                                    (click)="saveOrUpdateHhgCsi()" [disabled]="!isCsiValid()">Save
                                                  </button>
                                                }
                                                @if (this.isSelected) {
                                                  <button type="button" class="usa-button usa-button--outline"
                                                    (click)="deleteHhgCsi()">Delete
                                                  </button>
                                                }
                                                @if (this.isSelected) {
                                                  <button type="button" class="usa-button usa-button--secondary"
                                                    (click)="onReset()"> Reset
                                                  </button>
                                                }
                                                <button type="button" class="usa-button usa-button--outline"
                                                  (click)="viewAuditTrailCustomerSatisfactionIndex()">View Audit Trail
                                                </button>
                                              </div>
                                              @if (this.showCsiTable) {
                                                <div>
                                                  <div class="usa-table usa-table--borderless">
                                                    <ag-grid-angular class="ag-theme-alpine" style="width: 100%;" [rowData]="csiDetails"
                                                      [domLayout]="domLayout" [pagination]="true"
                                                      [paginationPageSize]="paginationPageSize" [columnDefs]="csiColumnDefs"
                                                      (gridReady)="onGridReady($event)">
                                                    </ag-grid-angular>
                                                  </div>
                                                </div>
                                              }
                                            </div>
                                          }
                                          @if (showCoreTsp) {
                                            <div>
                                              <div class="grid-row grid-gap mt-4">
                                                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-2 desktop:grid-col-2">
                                                  <button type="button" class="usa-button" (click)="openCoreTspModal('add', {})">
                                                    Add New Agency Group
                                                  </button>
                                                </div>
                                                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-2 desktop:grid-col-2">
                                                  <button type="button" class="usa-button usa-button--outline" (click)="viewAuditAgencyGroup()">
                                                    View Audit Trail
                                                  </button>
                                                </div>
                                                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-2 desktop:grid-col-2">
                                                  <button type="button" class="usa-button usa-button--secondary" (click)="deleteTspCoreNotifications()" [disabled]="isNoRowSelected$ | async">
                                                    Delete Selected
                                                  </button>
                                                </div>
                                              </div>
                                              <div class="grid-row grid-gap mt-4 justify-content-start">
                                                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                                                  <b>To edit an existing Agency Group, click on the corresponding hyperlink below</b>
                                                </div>
                                              </div>
                                              <div class="usa-table usa-table--borderless">
                                                <ag-grid-angular class="ag-theme-alpine" style="width: 100%;" [rowSelection]="'multiple'"
                                                  [rowData]="agencyCoreTsps" [domLayout]="domLayout" [pagination]="true" [gridOptions]="detailGridOptions"
                                                  [paginationPageSize]="paginationPageSize" [columnDefs]="coreTspColumnDefs"
                                                  (gridReady)="onGridReady($event)" ag-grid-resize>
                                                </ag-grid-angular>
                                              </div>
                                            </div>
                                          }
                                        </form>
                                      </div>

                                      <div bsModal #createModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-create-user"
                                        [config]="{backdrop: 'static'}">
                                        <div class="usa-modal usa-modal--lg display-flex" id="example-modal-2" aria-labelledby="modal-2-heading"
                                          aria-describedby="modal-2-description">
                                          <div class="usa-modal__content">
                                            <div class="usa-modal__main padding-y-0 define-width">
                                              <h2 class="usa-modal__heading" id="modal-2-heading">
                                                {{isCoreTspEdit ? 'Agency Core TSP Notification' : 'New Agency Core TSP Notification'}}
                                              </h2>
                                              <div class="usa-prose">
                                                @if (!isCoreTspEdit) {
                                                  <form id="masterDataAdminForm1" role="form" [formGroup]="coreTspForm">
                                                    <div class="grid-row grid-gap">
                                                      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                                                        <label for="new_agency" class="usa-label">New Agency Group Description<abbr title="required"
                                                        class="usa-hint usa-hint--required">*</abbr></label>
                                                        <input type="text" formControlName="agencyGroup" id="new_agency" class="usa-input" maxlength="254">
                                                      </div>
                                                      @if (this.coreTspForm.get('agencyGroup').hasError('required') && (this.coreTspForm.get('agencyGroup').touched || this.coreTspForm.get('agencyGroup').dirty)) {
                                                        <div
                                                          >
                                                          <small class="text-danger">
                                                            <span class="fa fa-warning"></span> This field is required
                                                          </small>
                                                        </div>
                                                      }
                                                    </div>
                                                    <div class="grid-row grid-gap">
                                                      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                                                        <label for="agency_emails" class="usa-label">Agency User Emails (Please separate them by commas)<abbr
                                                        title="required" class="usa-hint usa-hint--required">*</abbr></label>
                                                        <input type="text" formControlName="agencyEmails" id="agency_emails" class="usa-input" maxlength="254">
                                                      </div>
                                                      @if (this.coreTspForm.get('agencyEmails').hasError('required') && (this.coreTspForm.get('agencyEmails').touched || this.coreTspForm.get('agencyEmails').dirty)) {
                                                        <div
                                                          >
                                                          <small class="text-danger">
                                                            <span class="fa fa-warning"></span> This field is required
                                                          </small>
                                                        </div>
                                                      }
                                                      @if (this.coreTspForm.get('agencyEmails').hasError('invalidEmails') && (this.coreTspForm.get('agencyEmails').touched || this.coreTspForm.get('agencyEmails').dirty)) {
                                                        <div
                                                          >
                                                          <small class="text-danger">
                                                            <span class="fa fa-warning"></span> Please enter emails seperated by commas
                                                          </small>
                                                        </div>
                                                      }
                                                    </div>
                                                    <div class="grid-row grid-gap">
                                                      <div class="grid-col-5 mobile-lg:grid-col-12 tablet:grid-col-5 desktop:grid-col-5">
                                                        <label for="chargebleCodeAdd" class="usa-label text-bold"> TSP(s)</label>
                                                        <select id="chargebleCodeAdd" multiple class="define-height-usa-select usa-select maxw-full"
                                                          formControlName="appCarriers" title="Available Charge Codes" name="appChargeCodeList"
                                                          aria-label="Select from available Appropriation Charge Codes">
                                                          <option value='null'>-Select TSP(s)-</option>
                                                          @for (mdt of carrierList; track mdt) {
                                                            <option [ngValue]="mdt">{{mdt.scac}}- {{mdt.scacName}}</option>
                                                          }
                                                        </select>
                                                        <div style="font-weight: 700;">Use "CTRL" to select multiple SCACs.</div>
                                                      </div>
                                                      <div class="grid-col-2 mobile-lg:grid-col-12 tablet:grid-col-2 desktop:grid-col-2 text-center define-margin-x-y-auto">
                                                        <button type="button" class="usa-button usa-button--hover width-full" (click)="moveItems()">
                                                          <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                                            <use xlink:href="/assets/uswds/img/sprite.svg#arrow_forward"></use>
                                                          </svg>
                                                        </button>
                                                      </div>
                                                      <div class="grid-col-5 mobile-lg:grid-col-12 tablet:grid-col-5 desktop:grid-col-5">
                                                        <label for="assigned_rate_type_add" class="usa-label text-bold">Core TSP(s)</label>
                                                        <select multiple id="assigned_rate_type_add" formControlName="assignedCarriers"
                                                          class="define-height-usa-select usa-select maxw-full">
                                                          @for (assginedChargeCode of assignedCarriers; track assginedChargeCode; let i = $index) {
                                                            <option
                                                              [value]="assginedChargeCode.carrierId"
                                                              (dblclick)="handleRateTypesMultiDropdown(i)">
                                                              {{assginedChargeCode.scac}}- {{assginedChargeCode.scacName}}
                                                            </option>
                                                          }
                                                        </select>
                                                        <div style="font-weight: 700;">Double click on a TSP to remove.</div>
                                                      </div>
                                                    </div>
                                                  </form>
                                                }
                                                @if (isCoreTspEdit) {
                                                  <form id="masterDataAdminForm11" role="form" [formGroup]="coreTspForm">
                                                    <div class="grid-row grid-gap">
                                                      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                                                        <label for="agency" class="usa-label">Agency Group Description<abbr title="required"
                                                        class="usa-hint usa-hint--required">*</abbr></label>
                                                        <input type="text" formControlName="agencyGroup" id="agency" class="usa-input" maxlength="254">
                                                      </div>
                                                      @if (this.coreTspForm.get('agencyGroup').hasError('required') && (this.coreTspForm.get('agencyGroup').touched || this.coreTspForm.get('agencyGroup').dirty)) {
                                                        <div
                                                          >
                                                          <small class="text-danger">
                                                            <span class="fa fa-warning"></span> This field is required
                                                          </small>
                                                        </div>
                                                      }
                                                    </div>
                                                    <div class="grid-row grid-gap">
                                                      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                                                        <label for="agency_emails_edit" class="usa-label">Agency User Emails (Please separate them by
                                                          commas)<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
                                                          <input type="text" formControlName="agencyEmails" id="agency_emails_edit" class="usa-input"
                                                            maxlength="254">
                                                          </div>
                                                          @if (this.coreTspForm.get('agencyEmails').hasError('required') && (this.coreTspForm.get('agencyEmails').touched || this.coreTspForm.get('agencyEmails').dirty)) {
                                                            <div
                                                              >
                                                              <small class="text-danger">
                                                                <span class="fa fa-warning"></span> This field is required
                                                              </small>
                                                            </div>
                                                          }
                                                          @if (this.coreTspForm.get('agencyEmails').hasError('invalidEmails') && (this.coreTspForm.get('agencyEmails').touched || this.coreTspForm.get('agencyEmails').dirty)) {
                                                            <div
                                                              >
                                                              <small class="text-danger">
                                                                <span class="fa fa-warning"></span> Please enter emails seperated by commas
                                                              </small>
                                                            </div>
                                                          }
                                                        </div>
                                                        <div class="grid-row grid-gap">
                                                          <div class="grid-col-5 mobile-lg:grid-col-12 tablet:grid-col-5 desktop:grid-col-5">
                                                            <label for="chargebleCodeEdit" class="usa-label text-bold">TSP(s)</label>
                                                            <select id="chargebleCodeEdit" multiple class="define-height-usa-select usa-select maxw-full"
                                                              formControlName="appCarriers" title="Available Charge Codes" name="appChargeCodeList"
                                                              aria-label="Select from available Appropriation Charge Codes">
                                                              <option value='null'>-Select TSP(s)-</option>
                                                              @for (mdt of carrierList; track mdt) {
                                                                <option [ngValue]="mdt">{{mdt.scac}}- {{mdt.scacName}}</option>
                                                              }
                                                            </select>
                                                            <div style="font-weight: 700;">Use "CTRL" to select multiple SCACs.</div>
                                                          </div>
                                                          <div class="grid-col-2 mobile-lg:grid-col-12 tablet:grid-col-2 desktop:grid-col-2 text-center define-margin-x-y-auto">
                                                            <button type="button" class="usa-button usa-button--hover width-full" (click)="moveItems()">
                                                              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                                                <use xlink:href="/assets/uswds/img/sprite.svg#arrow_forward"></use>
                                                              </svg>
                                                            </button>
                                                          </div>
                                                          <div class="grid-col-5 mobile-lg:grid-col-12 tablet:grid-col-5 desktop:grid-col-5">
                                                            <label for="assigned_rate_type_edit" class="usa-label text-bold">Core TSP(s)
                                                            Codes</label>
                                                            <select multiple id="assigned_rate_type_edit" formControlName="assignedCarriers"
                                                              class="define-height-usa-select usa-select maxw-full">
                                                              @for (assginedChargeCode of assignedCarriers; track assginedChargeCode; let i = $index) {
                                                                <option
                                                                  [value]="assginedChargeCode.carrierId"
                                                                  (dblclick)="handleRateTypesMultiDropdown(i)">
                                                                  {{assginedChargeCode.scac}}- {{assginedChargeCode.scacName}}
                                                                </option>
                                                              }
                                                            </select>
                                                            <div style="font-weight: 700;">Double click on a TSP to remove.</div>
                                                          </div>
                                                        </div>
                                                      </form>
                                                    }
                                                  </div>
                                                  <div class="usa-modal__footer">
                                                    <ul class="usa-button-group">
                                                      <li class="usa-button-group__item">
                                                        <button type="button" class="usa-button" (click)="onTspSave()" [disabled]="coreTspForm.invalid || assignedCarriers.length === 0">
                                                          Save
                                                        </button>
                                                      </li>
                                                      <li class="usa-button-group__item">
                                                        <button
                                                          type="button"
                                                          class="usa-button usa-button--unstyled padding-105 text-center"
                                                          data-close-modal
                                                          (click)="closeModal()">
                                                          Close
                                                        </button>
                                                      </li>
                                                    </ul>
                                                  </div>
                                                </div>
                                                <button class="usa-button usa-modal__close" aria-label="Close this window" (click)="createModal.hide()"
                                                  data-close-modal>
                                                  <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                                    <use xlink:href="/assets/uswds/img/sprite.svg#close"></use>
                                                  </svg>
                                                </button>
                                              </div>
                                            </div>
                                          </div>
